import React, {useState, useEffect} from "react";
import { Book, Clock, Star, Users } from "lucide-react";
import Button from "../ui/Button";
import Slider from "../ui/Slider";
import { Link } from "react-router-dom";
import axios from "axios";
import { host } from "../../api/ApiCalls";
import RecommendedCoursesSkeleton from "../skeleton/RecommendedCoursesSkeleton";


const RecommendedCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axios.get(`${host}/api/courses/top-enrolled`);
        setCourses(res.data);
      } catch (err) {
        console.error("Error fetching courses", err);
      }finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  if (loading) return <RecommendedCoursesSkeleton />;
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Recommended Courses</h2>
          <p className="text-xl text-gray-600">
            Explore our most popular courses taught by expert instructors
          </p>
        </div>

       <Slider>
  {courses.map((course) => (
    <div key={course._id} className="w-80 flex-shrink-0">
      <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all overflow-hidden h-full flex flex-col">
        <div className="relative">
          <img
            src={course.image}
            alt={course.title}
            className="w-full h-48 object-cover"
          />
          {course.rating && (
            <div className="absolute top-2 right-2 bg-yellow-400 text-white text-xs font-bold px-2 py-1 rounded">
              ⭐ {course.rating.toFixed(1)}
            </div>
          )}
        </div>

        <div className="flex-1 flex flex-col p-5">
          <h3 className="text-lg font-semibold text-gray-800 mb-1 line-clamp-1">
            {course.title}
          </h3>
          <p className="text-gray-500 text-sm mb-3 line-clamp-2">
            {course.description}
          </p>

          <div className="flex justify-between text-sm text-gray-500 mb-4">
            <div className="flex items-center gap-1">
              <Users className="h-4 w-4 text-indigo-500" />
              {Array.isArray(course.students)
                ? `${course.students.length}`
                : course.students}{" "}
              students
            </div>
            <div className="flex items-center gap-1">
              <Clock className="h-4 w-4 text-indigo-500" />
              {course.duration}
            </div>
          </div>

          <div className="mt-auto flex items-center justify-between">
            <span className="text-indigo-600 font-bold text-lg">
              ${course.price}
            </span>
            <Link to={`/courses/${course._id}`}>
              <Button size="sm">Enroll Now</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  ))}

  {/* Show More Slide */}
  <div className="w-80 flex-shrink-0 flex justify-center items-center">
    <Link to="/courses" className="group w-full h-full flex justify-center items-center border-2 border-dashed border-indigo-300 rounded-2xl hover:bg-indigo-50 transition">
      <div className="flex flex-col items-center">
        <span className="text-indigo-600 group-hover:text-indigo-800 text-3xl">
          →
        </span>
        <span className="text-gray-500 group-hover:text-gray-800 text-sm mt-2">
          Show More
        </span>
      </div>
    </Link>
  </div>
</Slider>

      </div>
    </section>
  );
};

export default RecommendedCourses;
